import React from 'react';
import { Badge } from '@material-ui/core';
import './index.scss';
import { ContratoStatus, StatusDetails, VersaoContratoDetails, VersaoContratoEnum } from 'models/contratos';

interface StatusBadgeProps {
    status?: ContratoStatus;
    versaoContrato?: VersaoContratoEnum;
    className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, versaoContrato, className }) => {
    const statusDetail = status !== undefined ? StatusDetails[status] : null;
    const tipoContratoDetail = versaoContrato !== undefined ? VersaoContratoDetails[versaoContrato] : null;

    const badgeStyle = {
        backgroundColor: statusDetail ? statusDetail.color : 'transparent',
        padding: statusDetail && !tipoContratoDetail ? '1px 7px' : '0',
    };

    return (
        <Badge overlap='rectangular' className={`newBadge ${className || ''}`} style={badgeStyle}>
            {statusDetail ? statusDetail.label : ''}
            {tipoContratoDetail ? ` ${tipoContratoDetail.label}` : ''}
        </Badge>
    );
};

export default StatusBadge;
